const api = require("./api");
const auth = require("./auth");
const memo = require("./auth/memo");
const broadcast = require("./broadcast");
const config = require("./config");
const formatter = require("./formatter")(api);
const utils = require("./utils");

const hivejs = {
  api,
  auth,
  memo,
  broadcast,
  config,
  formatter,
  utils
};

if (typeof window !== "undefined") {
  window.hivejs = hivejs;
}

if (typeof global !== "undefined") {
  global.hivejs = hivejs;
}

exports = module.exports = hivejs;



// WEBPACK FOOTER //
// ./src/browser.js